/*
  This is the standard component-slider.js from Shopify's Dawn theme.
  It provides the functionality for carousels (<slider-component>).
*/
if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.init();
      }

      init() {
        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        this.update();
      }

      onButtonClick(event) {
        event.preventDefault();
        const slideScrollPosition =
          event.currentTarget.name === 'next'
            ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
            : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
        this.slider.scrollTo({
          left: slideScrollPosition,
          behavior: 'smooth' // Added for smooth scrolling
        });
      }

      update() {
        if (!this.currentPageElement || !this.pageTotalElement) return;
        const visibleSlide = Array.from(this.sliderItems).find(
          (slide) => slide.offsetLeft >= this.slider.scrollLeft
        );
        this.currentPage = Array.from(this.sliderItems).indexOf(visibleSlide) + 1;
        
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.sliderItems.length; // Ensure this is updated if needed

        // Check scroll position for button states
        const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;

        if (this.slider.scrollLeft <= 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }

        if (this.slider.scrollLeft >= maxScrollLeft - 1) { // Added a small tolerance
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }

         // Optional: Looping logic (currently disabled, can be enabled if needed)
         /*
         if (!this.enableSliderLooping) return;

         if (this.isSlideVisible(this.sliderItems[0]) && this.slider.scrollLeft === 0) {
           this.prevButton.setAttribute('disabled', 'disabled');
         } else {
           this.prevButton.removeAttribute('disabled');
         }

         if (this.isSlideVisible(this.sliderItems[this.sliderItems.length - 1])) {
           this.nextButton.setAttribute('disabled', 'disabled');
         } else {
           this.nextButton.removeAttribute('disabled');
         }
         */
      }

      // Helper function (if looping is needed)
      /*
      isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
      }
      */
    }
  );
}